define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var SupplierModel = /** @class */ (function () {
        function SupplierModel(data) {
            this.Id = ko.observable(0);
            this.Name = ko.observable();
            this.SystemKey = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, SupplierModel.Mapping, self);
            }
        }
        SupplierModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new SupplierModel(options.data);
            }
        };
        return SupplierModel;
    }());
    return SupplierModel;
});
//# sourceMappingURL=SupplierModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/SupplierModel.js
// module id = 303
// module chunks = 2